module.exports = __webpack_public_path__ + "static/img/Kenti4.31e1d0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Kenti4.jpg
// module id = hsv2
// module chunks = 0